export class ProductFeatureVM {
  id: any;
  name?: string;
  order?: number;
}